export default {"src":"/nachrichten/_next/static/media/ThemeLightIcon.4a32ef75.svg","height":124,"width":70,"blurWidth":0,"blurHeight":0};